import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import {TimKiemNangCaoService } from '../service/tim-kiem-nang-cao.service';
import { QueryParamsModel, BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';

export class TimKiemNangCaoDataSource extends BaseDataSource {
	constructor(private productsService:TimKiemNangCaoService) {
		super();
	}
	loadTimKiemNangCaos(queryParams: QueryParamsModel) {
		this.productsService.lastFilter$.next(queryParams);
		this.productsService.lastFilterDN$.next(queryParams);
        this.loadingSubject.next(true);
		this.productsService.getData(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer.data != null && resultFromServer.data != undefined) {
						this.entitySubject.next(resultFromServer.data);
						this.paginatorTotalSubject.next(resultFromServer.page.TotalCount);
					}
					else {
						this.entitySubject.next(null);
						this.paginatorTotalSubject.next(null);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
}
